import { createContext } from 'react'

import type { TicketStore } from '@web/services/store/ticket.store'

export const TicketContext = createContext<TicketStore | null>(null)
